import React from "react";
import "./WelcomeScreen.css";

// Shown only during the brief window before the WebSocket connects. Once
// connected, the greeting is seeded into the message list as a real chat
// bubble (see useWebSocket.js) and this component is no longer rendered.
export default function WelcomeScreen() {
  return (
    <div className="welcome-screen">
      <div className="welcome-body">
        <div className="welcome-logo">
          <div className="skeleton logo" />
        </div>
        <div className="welcome-text">
          <div className="skeleton line medium" />
          <div className="skeleton line medium" />
          <div className="skeleton line short" />
        </div>
      </div>
    </div>
  );
}
